import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class CloseButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.general.closeButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="29.41 5.41 26.59 2.59 16 13.17 5.41 2.59 2.59 5.41 13.17 16 2.59 26.59 5.41 29.41 16 18.83 26.59 29.41 29.41 26.59 18.83 16 29.41 5.41" />
				</svg>
			</i>
		</Button>;
	}
}
